import PropTypes from 'prop-types'
import classNames from 'classnames'

import AbbreviatedNumber from 'components/AbbreviatedNumber'
import useTextOverflowClass from 'hooks/useTextOverflowClass'

import s from './TiktokCount.module.css'

const enableTikTok =
  parseInt(process.env.NEXT_PUBLIC_ENABLE_TIKTOK ?? '0', 10) === 1
const enableTikTokCount =
  parseInt(process.env.NEXT_PUBLIC_ENABLE_TIKTOK_COUNT ?? '0', 10) === 1

function TiktokCount({
  tiktok = [],
  colour = '#000',
  className = '',
  iconClassName = '',
}) {
  const setUser = tiktok?.[0]?.username
  const { ref: refText, className: overflowClassName } = useTextOverflowClass(
    s.marquee,
    setUser
  )

  if (!enableTikTok) {
    return <></>
  }

  if (!tiktok || tiktok?.length < 1) return null

  const setCount = tiktok[1]?.count

  return (
    <a
      href={`https://www.tiktok.com/@${setUser}`}
      target="_blank"
      rel="reopener noreferrer"
      className={classNames(s.container, className)}
      style={{ color: colour }}
    >
      <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.8811 8.5693V5.06663C16.2408 5.06663 14.9889 4.6288 14.1811 3.7778C13.352 2.80658 12.8875 1.57664 12.8676 0.299797V0.0469636L9.5561 -0.0332031C9.5561 -0.0332031 9.5561 0.10863 9.5561 0.299797V14.1933C9.4425 14.814 9.14119 15.3849 8.69285 15.829C8.24451 16.273 7.67071 16.5688 7.04894 16.6764C6.42716 16.784 5.78733 16.6983 5.21584 16.4307C4.64434 16.1632 4.1687 15.7267 3.85311 15.1803C3.53752 14.6339 3.39719 14.0037 3.45106 13.375C3.50492 12.7463 3.7504 12.1493 4.15434 11.6645C4.55828 11.1797 5.10124 10.8305 5.70992 10.6641C6.3186 10.4977 6.96369 10.522 7.5581 10.7338V7.34213C7.21152 7.28534 6.86095 7.25647 6.50976 7.2558C5.2462 7.2558 4.01102 7.63049 2.96041 8.33248C1.9098 9.03448 1.09095 10.0323 0.607405 11.1996C0.123862 12.367 -0.00265501 13.6516 0.243853 14.8908C0.490361 16.1301 1.09882 17.2685 1.99229 18.1619C2.88576 19.0554 4.02412 19.6639 5.2634 19.9104C6.50268 20.1569 7.78722 20.0304 8.9546 19.5468C10.122 19.0633 11.1198 18.2444 11.8217 17.1938C12.5237 16.1432 12.8984 14.908 12.8984 13.6445C12.8977 13.3827 12.8813 13.1211 12.8491 12.8613V7.2188C14.3549 8.15918 16.1068 8.62936 17.8811 8.5693Z"
          fill="black"
        />
      </svg>
      <span className={s.user}>
        <span
          ref={refText}
          className={classNames(s.userText, overflowClassName)}
        >
          {setUser}
        </span>
      </span>
      {enableTikTokCount && setCount && (
        <span className={s.count}>
          <AbbreviatedNumber>{setCount}</AbbreviatedNumber> followers
        </span>
      )}
    </a>
  )
}

TiktokCount.propTypes = {
  tiktok: PropTypes.array,
  colour: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
}

export default TiktokCount
